<div
  class="filter"
  [ngClass]="{ expanded: isExpanded }"
  [attr.data-test]="label"
>
  <cigna-filter-label-shared
    [filterName]="label"
    [customLabel]="customLabel"
    (labelClick)="openFilters.emit()"
    data-test="filter-date-label"
  ></cigna-filter-label-shared>

  <div class="cg-margin-top-md" *ngIf="isExpanded">
    <form [formGroup]="dateForm">
      <div
        *ngIf="!!_filterState?.options?.length"
        class="cg-margin-bottom-sm"
        data-test="filter-date-options"
      >
        <ng-container *ngFor="let option of _filterState.options">
          <label class="chcp-radio cg-margin-right-md" [for]="option.value">
            <input
              type="radio"
              [id]="option.value"
              formControlName="option"
              [value]="option.value"
            />
            <i class="chcp-radio-img"></i>
            <span class="chcp-radio-label">{{ option.label }}</span>
          </label>
        </ng-container>
      </div>
      <div class="cg-margin-bottom-md">
        <select
          cignaSelect
          formControlName="range"
          data-test="filter-date-select"
        >
          <option *ngFor="let option of rangeOptions" [value]="option.value">
            {{ option.description }}
          </option>
        </select>
      </div>
      <div *ngIf="range.value !== 'all'" class="cg-flex">
        <div class="cg-field-container cg-margin-right-sm">
          <div class="cg-margin-bottom-xs">
            <label for="dateFilterFrom">From </label>
          </div>
          <div>
            <div class="cg-datepicker-wrap">
              <input
                id="dateFilterFrom"
                cignaInput
                type="text"
                autocomplete="nope"
                [matDatepicker]="picker"
                [formControl]="min"
                [ngClass]="{ 'read-only-date-picker': isDateReadOnly }"
                [readonly]="isDateReadOnly"
                [min]="minFromDate"
                [max]="maxDate"
                data-test="filter-date-input-from"
              />
              <div [ngStyle]="{ display: isDateReadOnly ? 'none' : 'inline' }">
                <mat-datepicker-toggle matSuffix [for]="picker" tabindex="-1">
                  <cigna-icon
                    matDatepickerToggleIcon
                    alt="calendar icon"
                    role="button"
                    type="calendar-alt"
                  ></cigna-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="cg-field-container">
          <div class="cg-margin-bottom-xs">
            <label for="dateFilterTo">To </label>
          </div>
          <div>
            <div class="cg-datepicker-wrap">
              <input
                id="dateFilterTo"
                cignaInput
                type="text"
                autocomplete="nope"
                [matDatepicker]="pickerTo"
                [formControl]="max"
                [ngClass]="{ 'read-only-date-picker': isDateReadOnly }"
                [readonly]="isDateReadOnly"
                [max]="maxDate"
                [min]="minFromDate"
                data-test="filter-date-input-to"
              />
              <div [ngStyle]="{ display: isDateReadOnly ? 'none' : 'inline' }">
                <mat-datepicker-toggle matSuffix [for]="pickerTo" tabindex="-1">
                  <cigna-icon
                    matDatepickerToggleIcon
                    alt="calendar icon"
                    role="button"
                    type="calendar-alt"
                  ></cigna-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="cg-error-msg"
        *ngIf="!dateForm.valid"
        data-test="date-error-msg"
      >
        <cigna-icon type="exclamation-circle"></cigna-icon>
        <span>From date must be before To date</span>
      </div>
    </form>
  </div>
</div>
